// extracted by mini-css-extract-plugin
export default {"wrapper":"seedIcon_wrapper__q2A3s"};